import { inject, Input } from '@angular/core';
import find from 'lodash-es/find';
import { Model } from '@df/catalog/model';
import { ListingFilter } from '@df/catalog-ui/listing/listing';
import { FilterAttributeRange, IRangeMeta } from '@df/catalog-ui/listing/filter/filter-attribute-range';
import { FilterComponentDef } from '@df/catalog-ui/listing/filter/filter.component.def';

const rangeDummy = ListingFilter({
    filterType: 'attribute-range'
});

rangeDummy(FilterAttributeRange);

import { Directive } from '@angular/core';
import { NUi } from '@df/ui/df-ui.config';
@Directive()
export class FilterAttributeRangeComponentDef<T extends Model> extends FilterComponentDef<T> {
    /**
     * Filter model binding
     */
    @Input({
        required: true
    })
    override filter!: FilterAttributeRange<T>;

    private moduleConfig = inject(NUi.OPTIONS);

    step = this.moduleConfig.filter?.range?.step;

    protected getOptionsWithCurrentMatches(filter = this.filter, metaMin = this.metaMin, metaMax = this.metaMax): IRangeMeta[] {
        const ranges: IRangeMeta[] = [];

        if (!this.step) {
            console.log('Please set filter range step in app configuration');
            this.step = 25;
        }

        if (metaMin >= 0 && metaMax) {
            // min start price that is nearest smaller multiple of step
            let i = Math.floor(metaMin / this.step) * this.step;

            while (i <= metaMax) {
                const minValue = i;
                // max if is smaller than max price
                const maxValue = minValue + this.step > metaMax ? undefined : minValue + this.step;

                if (this.hasAnyCurrentMatchesRange(filter, minValue, maxValue)) {
                    ranges.push({
                        min: minValue,
                        max: maxValue!
                    });
                }

                i += this.step;
            }
        }

        return ranges;
    }

    hasAnyCurrentMatchesRange(filter: any, minValue?: number, maxValue?: number): boolean {
        if (filter.listing) {
            const models: Model[] = filter.listing.getSourceModels();

            // filtered attribute code
            const attributeCode = filter.id;

            return !!find(models, model => {
                const value = model.data ? model.data[attributeCode] : undefined;

                // if value is not set then false
                if (value === undefined) {
                    return false;
                }

                // check min value if set
                if (minValue !== undefined && minValue > value) {
                    return false;
                }

                // check max value if set
                return !(maxValue !== undefined && maxValue < value);
            });
        }

        return true;
    }

    override canShow(filter: FilterAttributeRange<T>) {
        return filter.filterType === 'attribute-range' ? this.optionsWithCurrentMatches.length > 1 : true;
    }

    get optionsWithCurrentMatches() {
        return this.getOptionsWithCurrentMatches();
    }

    get metaMax(): number {
        return this.filter.getMetaData()?.max ?? 0;
    }

    get metaMin(): number {
        return this.filter.getMetaData()?.min ?? 0;
    }
}
